import { render, staticRenderFns } from "./DonationForm.vue?vue&type=template&id=2ba5d3d2"
import script from "./DonationForm.vue?vue&type=script&lang=js"
export * from "./DonationForm.vue?vue&type=script&lang=js"
import style0 from "./DonationForm.vue?vue&type=style&index=0&id=2ba5d3d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports